import { render, staticRenderFns } from "./AppAuthenticationConfirmSignup.vue?vue&type=template&id=137f0133&"
import script from "./AppAuthenticationConfirmSignup.vue?vue&type=script&lang=ts&"
export * from "./AppAuthenticationConfirmSignup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports